import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Layout/layout"
import ContenuLibre from "gatsby-theme-cactus/src/gatsby-theme-blank/components/ContenuLibre/contenu-libre"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import {
  listActualitesContainer,
  contentContainer,
  zoneLibreContainer,
  actuItem,
} from "./styles/listActus.module.scss"
import FadeIn from "react-fade-in"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { ActuItem, AllBtn } from "./styled-components/actualites-styled"
import SEO from "gatsby-theme-blank/src/components/seo"
import ActualiteItem from "./listItems/actualite-item"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"

//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query {
    allTaxonomyTermThematiques(
      filter: {
        relationships: {
          node__actualites: { elemMatch: { status: { eq: true } } }
        }
      }
    ) {
      ...ListActualitesTaxo
    }
    allNodeActualites(sort: { fields: created, order: DESC }) {
      ...ListActualites
    }
  }
`
//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//

const ActualitesTemplate = ({ data }) => {
  const buildColors = useBuildData().theme_settings.palette
  const allTaxos = data.allTaxonomyTermThematiques.edges
    .map(({ node }) => {
      return node.name
    })
    .join()
  return (
    <Layout>
      <SEO
        title="Liste des actualités"
        description={
          "Dans cette page, vous découvrez toutes les actualités, mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
      />
      <FadeIn delay={100} transitionDuration={400}>
        <Ariane pageName="Toutes les actualités" isListing={true} />
        <section className={contentContainer}>
          <div className={listActualitesContainer}>
            <RenderActualites colors={buildColors} actualiteData={data} />
          </div>
          <div className={zoneLibreContainer}>
            <ContenuLibre isIndex={true} zoneTaxoLibre="zone_actualites_haut" />
            <ContenuLibre isIndex={true} zoneTaxoLibre="zone_actualites_bas" />
          </div>
        </section>
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderActualites = ({ actualiteData, colors }) => {
  const actus = getPublishedData(actualiteData.allNodeActualites.edges)
  const [numberOfItems, setNumberOfItems] = useState(6)
  const finalFilteredData = actus.slice(0, numberOfItems)
  const othersData = actus.slice(numberOfItems)
  return (
    <>
      {finalFilteredData.map(({ node }) => (
        <ActuItem key={node.drupal_id} className={actuItem}>
          <ActualiteItem colors={colors} actu={node} />
        </ActuItem>
      ))}
      {othersData.length > 0 && (
        <div className="voirPlus">
          <AllBtn
            role="button"
            tabIndex={0}
            onClick={() => setNumberOfItems(numberOfItems + 6)}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                setNumberOfItems(numberOfItems + 6)
              }
            }}
            className="btn"
          >
            Voir plus
          </AllBtn>
        </div>
      )}
    </>
  )
}
//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

ActualitesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default ActualitesTemplate
